import { render, staticRenderFns } from "./TwoFactorUpsellNotice.vue?vue&type=template&id=28c5b094&scoped=true&"
import script from "./TwoFactorUpsellNotice.vue?vue&type=script&lang=js&"
export * from "./TwoFactorUpsellNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5b094",
  null
  
)

export default component.exports